import { Helmet } from 'react-helmet-async';

import { styled } from '@mui/material/styles';
import { Card, Container } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')({
    maxWidth: 900,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: 30,
    marginTop: 20,
});

// ----------------------------------------------------------------------

export default function PrivacyPage() {
    return (
        <>
            <Helmet>
                <title>AI Exchange .Live | Privacy Policy</title>
            </Helmet>

            <Container>
                <StyledContent sx={{ textAlign: 'left', alignItems: 'center' }}>
                    <Card sx={{ width: '100%', px: 6, py: 4, mt: 2, mb: 1 }}>
                        <h2>
                            Privacy Policy
                        </h2>

                        <p>
                        Effective date: 2025-03-01
                        </p>
                        <p>At <strong>AI Exchange .Live</strong>, we are committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, and protect any personal data you provide while using our website. By using our website, you agree to the terms of this policy.</p>

                        <h3>1. Information We Do Not Collect</h3>
                        <p>We do not collect any personal data or sensitive information from users who visit or use the website. We do not require you to submit personal details such as your name, email address, or any other identifiable information in order to access the services on our website.</p>

                        <h3>2. Use of Cookies</h3>
                        <p><strong>AI Exchange .Live</strong> does not use cookies or any other tracking technologies to collect or store personal information. Our website is designed to provide a seamless, anonymous experience without the need for cookies.</p>

                        <h3>3. How We Use the Information</h3>
                        <p>As we do not collect any personal data, we do not use any information for purposes such as advertising, analysis, or personalization. Our website provides informational content, including exchange rates and AI-generated market insights, solely for your reference and convenience.</p>

                        <h3>4. Third-Party Links</h3>
                        <p>Our website may contain links to external websites that are not operated or controlled by <strong>AI Exchange .Live</strong>. We are not responsible for the privacy practices or the content of such third-party websites. We encourage you to review the privacy policies of any third-party sites you visit.</p>

                        <h3>5. Data Security</h3>
                        <p>We are committed to ensuring that your data is secure. However, since we do not collect personal data, there is no need to store or protect any such information. The information available on our website is provided strictly for informational purposes and does not involve data collection practices.</p>

                        <h3>6. Changes to the Privacy Policy</h3>
                        <p><strong>AI Exchange .Live</strong> reserves the right to update or modify this Privacy Policy at any time. Any changes will be effective immediately upon posting the revised policy on this page. We encourage you to periodically review this Privacy Policy to stay informed about how we are protecting your privacy.</p>

                        <h3>7. Contact Us</h3>
                        <p>If you have any questions or concerns about this Privacy Policy or the practices of <strong>AI Exchange .Live</strong>, please feel free to contact us at <strong>contact@ai-exchange.live</strong>.</p>
                </Card>
                </StyledContent>
            </Container>
        </>
    );
}
